<template>
  <v-row>
      <v-col cols="12" :class="isFirstPage ? 'd-flex justify-end' :  'd-flex justify-space-between'">
        <v-btn v-if="hasPrevPage" text  :href="prev" class="accent my-3 px-8">Prev</v-btn>
        <v-btn v-if="hasNextPage" text  :href="next" class="accent my-3 px-8">Next</v-btn>
      </v-col>
    </v-row>
</template>

<script>
  export default {
    name: 'ArchivePagination',

    props: [
      'current',
      'max',
      'next',
      'page',
      'prev',
    ],

    computed: {
      isFirstPage() {
        return this.current == this.prev
      },
      isLastPage() {
        return this.max == this.page
      },
      hasNextPage() {
        return this.next !== this.current && ! this.isLastPage
      },
      hasPrevPage() {
        return this.prev !== this.current && ! this.isFirstPage
      }
    }
  }
</script>